import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';
import update from 'immutability-helper';

//helpers:
import { getData, postData } from '../../dataLib';

//actions:
import { modifyDatosCierreDiario } from '../../actions/cierre_diario_actions';
import { openDialog, hideDialog, setSaveState } from '../../actions/index';
import { getGrupoPartida } from '../../actions/grupo_partida_actions'

//components:
import NeuriteGrid from '../../components/neurite_grid';
import IntNumberFormatInput from '../../components/int_number_input_formatter';

//material ui components:
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

const styles = theme => ({
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    total: {
        display: 'flex',
        fontWeight: '500',
        textTransform: 'capitalize',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: 200,
        margin: '30px 8px 20px 0',
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 12,
    },
    input: {
        width: 80,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    buttonNew: {
        margin: '15px 8px',
        //padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        height: 50
    },
    divData: {
        position: 'relative'
    },
    cover: {
        position: 'absolute',
        height: 500,
        width: '100%',
        marginLeft: 8,
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 70,
    },
    formControlSelect: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 100,
    },
    divButton: {
        display: 'flex'
    },
});

class CierreDiarioPartidasTipoGrid extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            partidasPorTipo: [],
            tiposPartidaCentro: [],
            total: 0.00,
            newTipo: -1,
            newValue: 0,
            showSpinner: false,
            saveDisabled: true
        };
    };

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.grupoPartida !== this.props.grupoPartida) {
            this.getTiposPartidaCentro();
        }
        else if (prevState.tiposPartidaCentro !== this.state.tiposPartidaCentro) {
            if (this.state.tiposPartidaCentro.length > 0) {
                this.getPartidasPorTipo();
                this.setState({ ...this.state, showSpinner: true });
            }
        }

        else if (prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia || prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro) {
            this.getTiposPartidaCentro();
            this.setState({ ...this.state, showSpinner: true });
        }

    };

    calculateTotal = (rows) => {
        let total = 0.0;
        rows.forEach((r) => {
            total += parseFloat(r.numPartidas);
        })

        return total;
    };

    messageError = error => {

        this.props.openDialog('SimpleMessage', {
            message: error
        }, uuidv4(), false, 'sm');

    };

    checkValues = (partida) => {

        if (this.state.partidasPorTipo.find(p => (p.iTipopartidaElem === partida.iTipopartidaElem) && (p.id !== partida.id))) {
            this.messageError('Ya existen partidas para este tipo de partida');
            return false;
        }

        return true;
    };

    modifyPartidasPorTipo = (partida) => {
        var rows = this.state.partidasPorTipo.map((row) => {
            if (row.id === partida.id) {
                const tipoPartida = this.state.tiposPartidaCentro.find(tp => tp.id === parseInt(partida.iTipopartidaElem));
                return {
                    ...row,
                    numPartidas: partida.numPartidas,
                    iTipopartidaElem: parseInt(partida.iTipopartidaElem),
                    descr: partida.descr,
                    grupoPartida: this.props.grupoPartida.find(gp => gp.id === tipoPartida.iGrupoPartida).descr
                };
            }
            else return row;
        });
        this.props.setSaveState(true);
        this.setState({ ...this.state, partidasPorTipo: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    addPartidasPorTipo = (partida) => {
        const tipoPartida = this.state.tiposPartidaCentro.find(tp => tp.id === partida.iTipopartidaElem);
        partida.grupoPartida = this.props.grupoPartida.find(gp => gp.id === tipoPartida.iGrupoPartida).descr;
        let rows = this.state.partidasPorTipo.slice();
        rows.push(partida);
        this.props.setSaveState(true);
        this.setState({ ...this.state, partidasPorTipo: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    deletePartidasPorTipo = (partida) => {
        let rows = this.state.partidasPorTipo.filter(f => f.id !== partida.id);
        this.props.setSaveState(true);
        this.setState({ ...this.state, partidasPorTipo: rows, total: this.calculateTotal(rows), saveDisabled: false });
    };

    updatePartidasPorTipo = () => {

        this.setState({ ...this.state, saveDisabled: true });

        var partidas = this.state.partidasPorTipo.slice();
        partidas.forEach((f) => {
            if (typeof f.id !== 'number') f.id = -1;
            f.usuarioId = this.props.user ? this.props.user.profile.sub : 0;
        });

        let partidasURL = 'VPartidaPorTipo/partidas?date=' + this.props.centroDiaSelected.dia;
        if (this.props.producto !== undefined) partidasURL += '&centro_id=' + this.props.producto.centroId;
        else partidasURL += '&centro_id=' + this.props.centroDiaSelected.centro.id;

        postData(partidasURL,
            () => {
                this.props.hideDialog();
                this.props.openDialog('SimpleMessage', {
                    message: 'Partidas por tipo actualizadas'
                }, uuidv4(), false, 'sm');
                this.props.setSaveState(false);
                if (this.props.producto !== undefined) this.props.modifyDatosCierreDiario({ ...this.props.producto, button1: this.state.total });
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating partidas por tipo'
                }, uuidv4(), false, 'sm');
            },
            partidas,
            this.props.user
        );
    };

    getTiposPartidaCentro = () => {

        let partidasURL = 'VTipoPartidaCentro';

        if (this.props.producto !== undefined) partidasURL += '?centro_id=' + this.props.producto.centroId;
        else partidasURL += '?centro_id=' + this.props.centroDiaSelected.centro.id;


        getData(partidasURL,
            (response) => {
                if (response.data.length > 0) {
                    this.setState({ ...this.state, tiposPartidaCentro: response.data.filter(t => t.activo), newTipo: response.data[0].id, showSpinner: false });
                }
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching tipos partidas por centro'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );

    };

    getPartidasPorTipo = () => {

        let partidasURL = 'VPartidaPorTipo?date=' + this.props.centroDiaSelected.dia;

        if (this.props.producto !== undefined) partidasURL += '&centro_id=' + this.props.producto.centroId;
        else partidasURL += '&centro_id=' + this.props.centroDiaSelected.centro.id;

        getData(partidasURL,
            (response) => {
                const partidas = response.data.map(pt => {
                    const tipoPartida = this.state.tiposPartidaCentro.find(tp => tp.id === pt.iTipopartidaElem);
                    return { ...pt, grupoPartida: this.props.grupoPartida.find(g => g.id === tipoPartida.iGrupoPartida).descr }
                })
                this.setState({ ...this.state, partidasPorTipo: partidas, total: this.calculateTotal(response.data), showSpinner: false, })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching partidas'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );

    };

    componentDidMount = () => {
        this.props.getGrupoPartida();
    };

    deshacer = () => {
        this.setState({ ...this.state, showSpinner: true })
        this.getPartidasPorTipo();
    }


    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {

        if (fromRow !== toRow) return; //we only allow modficiation of a single row

        let updatedRow = update(this.state.partidasPorTipo[fromRow], { $merge: updated });

        if (this.checkValues(updatedRow)) {

            this.modifyPartidasPorTipo(updatedRow);
        }

    };

    handleGridNewRow = () => {
        const partida = {
            id: uuidv4(),
            iTipopartidaElem: this.state.newTipo,
            usuarioId: this.props.user ? this.props.user.profile.sub : 0,
            numPartidas: this.state.newValue,
            descr: this.state.tiposPartidaCentro.find(tp => tp.id === this.state.newTipo).descr,
            centroId: this.props.centroDiaSelected.centro.id,
            fecha: this.props.centroDiaSelected.dia,
        }

        if (this.checkValues(partida)) {

            const tipoPartida = this.state.tiposPartidaCentro.find(tp => tp.id === partida.iTipopartidaElem);
            partida.grupoPartida = this.props.grupoPartida.find(gp => gp.id === tipoPartida.iGrupoPartida).descr;
            let rows = this.state.partidasPorTipo.slice();
            rows.push(partida);
            this.props.setSaveState(true);
            this.setState({ ...this.state, partidasPorTipo: rows, total: this.calculateTotal(rows), newTipo: this.state.tiposPartidaCentro[0].id, newValue: 0, saveDisabled: false });
        }
    }


    renderGrid = () => {

        var columns = [];
        columns.push({ key: 'grupoPartida', name: 'Grupo de partidas', editable: false, dragable: false, width: 115 });
        columns.push({ key: 'iTipopartidaElem', name: 'Tipo de partida', editable: false, dragable: false, width: 200, type: 'dropdown' });
        columns.push({ key: 'numPartidas', name: 'Número de partidas', editable: !this.props.isDiaCerrado, dragable: false, type: 'int', width: 125 });

        const options = this.state.tiposPartidaCentro.map(p => {
            return { id: p.id, value: p.id, text: p.descr }
        })

        return (
            <NeuriteGrid
            id="c_d_p_t_g"
                columns={columns}
                rows={this.state.partidasPorTipo}
                buttonEdit={false}
                buttonDelete={!this.props.isDiaCerrado}
                onDeleteClick={this.deletePartidasPorTipo}
                onRowsUpdated={this.handleGridRowsUpdated}
                dropdownOptions={{
                    iTipopartidaElem: options
                }}
                height={500}
            />
        )

    }

    compare = (a, b) => {
        if (a.descr < b.descr)
            return -1;
        if (a.descr > b.descr)
            return 1;
        return 0;
    }

    fillTiposPartida = () => {
        return [...this.state.tiposPartidaCentro].sort(this.compare).map((tp, index) => {
            return (
                <option key={tp.id} value={tp.id}>{tp.descr}</option>
            );
        })
    }

    handleTipoChange = (event) => {

        const value = parseInt(event.target.value)

        this.setState({
            ...this.state,
            newTipo: value,
        });
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    }

    renderNewButton = () => {

        const { classes } = this.props;

        return (
            <div className={classes.divButton} >
                <span tabIndex="1" onFocus={() => document.getElementById("type_game_btn").focus() } /> 
                <FormControl style={{ marginTop: 16 }} className={classes.formControlSelect} >
                    <InputLabel htmlFor="tipo partidas">
                        Tipo de partida
                        </InputLabel>
                    <Select
                        native
                        autoFocus
                        id="type_game"
                        value={this.state.newTipo}
                        onChange={(event) => this.handleTipoChange(event)}
                        name="newTipo"
                        inputProps={{ style: { fontSize: 12 }, tabIndex: "2" }}
                    >
                        {this.fillTiposPartida()}
                    </Select>
                </FormControl>

                <FormControl className={classes.formControl}>
                    <TextField
                        id={'newValue'}
                        label={'Número de partidas'}
                        margin="normal"
                        value={this.state.newValue}
                        onChange={(event) => this.handleValueChange(event, 'newValue')}
                        InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput, inputProps: { tabIndex: "3" } }}
                    />
                </FormControl>
                <Button
                    id="type_game_btn"
                    type="submit"
                    disabled={this.props.isDiaCerrado || !this.props.centroDiaSelected.isValid}
                    variant="contained" color="primary" className={classes.buttonNew} tabIndex={4}
                    onClick={() => { this.handleGridNewRow() }}>Nuevo</Button>
                <span tabIndex="5" onFocus={() => document.getElementById("type_game").focus() } /> 
            </div>
        )
    }

    render() {
        const { classes } = this.props;

        return (
            !this.state.showSpinner ?

                <div className={classes.divData}>
                    <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>

                    {this.renderGrid()}
                    {this.renderNewButton()}

                    <div className={classes.total}>
                        <p style={{ margin: 0 }}>Total</p>

                        <TextField
                            id="total"
                            value={this.state.total}
                            disabled
                            variant="outlined"
                            className={classes.input}
                            InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                        />
                    </div>

                    <div>
                        {this.props.isDialog ?
                            <Button variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                            :
                            <Button hidden={this.props.isDiaCerrado} variant="contained" color="secondary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid} onClick={() => { this.deshacer() }}>Deshacer</Button>
                        }
                        {!this.props.isDiaCerrado ?
                            <Button variant="contained" color="primary" className={classes.button} disabled={!this.props.centroDiaSelected.isValid || this.state.saveDisabled} onClick={() => { this.updatePartidasPorTipo() }}>Guardar</Button>
                            : ''}
                    </div>
                </div>

                :

                <div className={classes.spinnerContainer}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
        );
    };

};


CierreDiarioPartidasTipoGrid.propTypes = {
    //state
    user: PropTypes.object,
    grupoPartida: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
    isDialog: PropTypes.bool,
    //dispatch
    modifyDatosCierreDiario: PropTypes.func.isRequired,
    getGrupoPartida: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    //parameters
    producto: PropTypes.object

};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
        grupoPartida: state.grupoPartida.grupospartida,
        user: state.oidc.user
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyDatosCierreDiario,
        getGrupoPartida,
        hideDialog,
        openDialog,
        setSaveState
    }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreDiarioPartidasTipoGrid));